const isEmpty = val => val === null || val === '' || !Object.keys(val).length;
const isNil = x => x == null;

export default variable => isNil(variable) || isEmpty(variable);
